//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ProteinExcretion',
  data() {
    return {
      defaultJson: {
        "Urinary protein": "尿蛋白",
        "Urinary creatinine": "尿肌酐",
        "Body surface area": "体表面积"
      },
      form: {
        protein: '',
        creatinine: '',
        surface: '',
      },
      hasScore: false,
      disabled: false,
      res: '...',
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = (form.protein / form.creatinine ) * 8.8 * form.surface / 1.73
        self.res = res.toFixed(1)

        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/ProteinExcretion.vue